import { useReactiveZone } from "reactive-zone/src/index.js";
import TaiBaseWidget from "../base.widget.js";

import emailTemplate from './Email.template.html';

class EmailWidget extends TaiBaseWidget {

    zone = useReactiveZone(this);
    refInput = this.zone.useElementRef('ref.input');

    template() {
        return emailTemplate
    }

    getValue() {
        return this.refInput.element.value;
    }

}

export default EmailWidget;